import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"

const limit = ReactDOM.createRoot(document.getElementById("limit"))
limit.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
